"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_STRING = exports.SNACK_DURATION_LONG = exports.SNACK_DURATION_MEDIUM = exports.SNACK_DURATION_SHORT = void 0;
exports.SNACK_DURATION_SHORT = 5000;
exports.SNACK_DURATION_MEDIUM = 7000;
exports.SNACK_DURATION_LONG = 10000;
exports.EMPTY_STRING = '';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnN0YW50cy9jb21tb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRVUsUUFBQSxvQkFBb0IsR0FBRyxJQUFJLENBQUM7QUFDNUIsUUFBQSxxQkFBcUIsR0FBRyxJQUFJLENBQUM7QUFDN0IsUUFBQSxtQkFBbUIsR0FBRyxLQUFLLENBQUM7QUFFNUIsUUFBQSxZQUFZLEdBQUcsRUFBRSxDQUFDIn0=